import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Timespan, TimespanValues } from '@pages-shared/topCharts';

export { Timespan };

export function TimespanSelector({
  activeTimespan,
  setActiveTimespan,
  variant,
}: {
  activeTimespan: Timespan;
  setActiveTimespan: (activeTimespan: Timespan) => void;
  variant: 'heading' | 'table';
}) {
  return (
    <OptionsList variant={variant}>
      {TimespanValues.map(key => (
        <li key={key}>
          <Button onClick={() => setActiveTimespan(key)} active={activeTimespan === key}>
            {key === 'all' ? 'All Time' : key}
          </Button>
        </li>
      ))}
    </OptionsList>
  );
}

const OptionsList = styled('ul', {
  listStyle: 'none',
  display: 'flex',
  alignItems: 'flex-start',

  variants: {
    variant: {
      heading: {
        justifyContent: 'center',
        // Align button text with table values
        marginRight: -8,

        '@tablet': {
          display: 'none',
        },
      },
      table: {
        display: 'none',
        marginLeft: 'auto',
        '@tablet': {
          display: 'flex',
        },
      },
    },
  },
});

const Button = styled('button', {
  backgroundColor: 'transparent',
  marginLeft: '8px',
  padding: '10px 8px 8px 8px',
  borderRadius: '8px',
  lineHeight: 1,
  transition: 'all 0.2s ease-in-out',
  fontWeight: 600,
  title: 'XS',
  color: '$base500',

  '@laptop': {
    padding: '12px 10px 14px 10px',
  },

  variants: {
    active: {
      true: {
        color: '$base800',
        backgroundColor: 'white',
      },
    },
  },
});
